import { trace } from "@opentelemetry/api";
import { ExternalToast, toast as sonnerToast } from "sonner";

const tracer = trace.getTracer("customer-portal-ui");

function createToastSpan(type: string, message: string) {
  const span = tracer.startSpan(`toast.${type}`, {
    attributes: {
      "toast.type": type,
      "toast.message_length": message.length,
    },
  });
  span.end();
}

export const toast = {
  success: (message: string, data?: ExternalToast) => {
    createToastSpan("success", message);
    return sonnerToast.success(message, data);
  },

  error: (message: string, data?: ExternalToast) => {
    createToastSpan("error", message);
    return sonnerToast.error(message, data);
  },

  info: (message: string, data?: ExternalToast) => {
    createToastSpan("info", message);
    return sonnerToast.info(message, data);
  },

  warning: (message: string, data?: ExternalToast) => {
    createToastSpan("warning", message);
    return sonnerToast.warning(message, data);
  },

  loading: (message: string, data?: ExternalToast) => {
    createToastSpan("loading", message);
    return sonnerToast.loading(message, data);
  },

  dismiss: (id?: string | number) => {
    return sonnerToast.dismiss(id);
  },

  promise: <T>(
    promise: Promise<T> | (() => Promise<T>),
    data: {
      loading: string;
      success: string | ((result: T) => string);
      error: string | ((error: unknown) => string);
    },
  ) => {
    const promiseSpan = tracer.startSpan("toast.promise");

    const wrappedPromise = async () => {
      try {
        const result = await (typeof promise === "function" ? promise() : promise);
        promiseSpan.setAttribute("toast.result", "success");
        return result;
      } catch (error) {
        promiseSpan.setAttribute("toast.result", "error");
        throw error;
      } finally {
        promiseSpan.end();
      }
    };

    return sonnerToast.promise(wrappedPromise(), data);
  },
};
